<template>
  <div class="loader">
    <p class="percentage">{{ formatedPercentage }} %</p>
  </div>
</template>

<script>
export default {
  name: "loader",
  props: {
    percentage: Number,
    isVisible: Boolean,
  },

  data() {
    return {
      tl: {},
      $percentage: null,
    };
  },

  watch: {
    isVisible(isVisible) {
      if (this.isVisible) {
        this.show();
      } else {
        this.hide();
      }
    },
  },

  computed: {
    formatedPercentage() {
      return parseInt(this.percentage);
    },
  },

  mounted() {
    this.$percentage = this.$el.querySelector(".percentage");
  },

  methods: {
    show() {
      this.tl.show = new TimelineMax({
        onComplete: this.onShowComplete,
        onCompleteScope: this,
        delay: 0.2,
      })
        .from(this.$el, 0.8, { y: "-100%", ease: Quart.easeOut }, 0)
        .from(
          this.$percentage,
          0.8,
          { y: this.$el.offsetHeight, ease: Quart.easeOut },
          0
        );
    },

    hide() {
      if (this.isVisible) {
        return;
      }

      this.$emit("before-hide");

      this.tl.hide = new TimelineMax({
        onComplete: this.onHideComplete,
        onCompleteScope: this,
        delay: 0.2,
      })
        .to(this.$el, 0.8, { y: "100%", ease: Quart.easeOut }, 0)
        .to(
          this.$percentage,
          0.8,
          { y: -this.$el.offsetHeight, ease: Quart.easeOut },
          0
        );
    },

    onHideComplete() {
      this.$emit("hidden");
      TweenMax.set(this.$el, { display: "none" });
    },

    onShowComplete() {
      this.$emit("shown");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~include-media/dist/_include-media.scss";

.loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: $blue;
  z-index: 120;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.percentage {
  color: $white;
  font-size: 100px;
  text-align: center;
  font-weight: 700;
  margin: 0;

  @include media("<=tablet") {
    font-size: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// Loader.vue?5725f8ea